<template>
  <div class="number">
    <input type="phone" maxlength="13" placeholder="请输入手机号码" v-model="phone" @input="handleInput" />
    <span class="record" @click="gotoRecord">充值记录</span>
    <span class="error" v-if="showError">{{errTip}}</span>
  </div>
</template>

<script>
let reg = /^(13[0-9]|14[57]|15[0-9]|16[0-9]|17[678]|18[0-9]|19[0-9])[0-9]{8}$/;
let num = /^[0-9]+$/;

import api from "../../api";

export default {
  data() {
    return {
      phone: "",
      showError: false,
      phoneFormat: "",
      errTip: "请输入正确的手机号码"
    };
  },
  watch: {
    phone(newValue, oldValue) {
      this.phone =
        newValue.length > oldValue.length
          ? newValue
              .replace(/\s/g, "")
              .replace(/(\d{3})(\d{0,4})(\d{0,4})/, "$1 $2 $3")
          : this.phone.trim();
    }
  },
  methods: {
    gotoRecord() {
      this.$routerPush(this, "/pages/charge/List");
    },
    handleInput() {
      this.phoneFormat = this.phone.replace(/\s*/g, "");

      if (num.test(this.phoneFormat)) {
        this.$emit("phone", this.phoneFormat);
        if (this.phoneFormat.length == 11) {
          if (!reg.test(this.phoneFormat)) {
            this.showError = true;
          } else {
            this.showError = false;
          }
        } else {
          this.showError = false;
        }
      } else {
        this.showError = true;
      }
    },
    getDefaultPhone() {
      api.charge.getDefaultPhone(res => {
        console.log(res);
        if (res.phone) {
          let dedaultPhone = res.phone;
          dedaultPhone = dedaultPhone
            .replace(/\s/g, "")
            .replace(/(\d{3})(\d{0,4})(\d{0,4})/, "$1 $2 $3");
          this.phone = dedaultPhone;
          this.phoneFormat = this.phone.replace(/\s*/g, "");
          this.$emit("phone", this.phoneFormat);
        }
      });
    }
  },
  mounted() {
    this.getDefaultPhone();
  }
};
</script>

<style lang="less" scoped>
.number {
  padding: 6.6vw 5.6vw 0 5.6vw;
  position: relative;
  input {
    width: 100%;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 4.06vw;
    font-size: 5vw;
  }
  .record {
    position: absolute;
    right: 5.6vw;
    top: 8vw;
    font-size: 4vw;
    color: #209df9;
  }
  .error {
    position: absolute;
    font-size: 4vw;
    color: #ff545b;
    top: 1vw;
    left: 5.6vw;
  }
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #ccc;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #ccc;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #ccc;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/charge/ChangeXInput.vue